/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import "aisztheme";

import React from "react";
import format from "date-fns/format";
import differenceInSeconds from "date-fns/difference_in_seconds";
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import { injectIntl } from "react-intl";
import {
  Button,
  DropdownButton,
  MenuItem,
  Panel,
  Table,
} from "react-bootstrap";
import Checkbox from "loracoms/Checkbox";
import Nvl from "loracoms/Nvl";
import SearchFlag from "loracoms/SearchFlag";
import SearchInput from "loracoms/SearchInput";
import ShowIf from "loracoms/ShowIf";
import SortBtn from "loracoms/SortBtn";
import TablePagers from "loracoms/TablePagers";
import LoadingTable from "loracoms/LoadingTable";
import PanelToolbar from "loracoms/PanelToolbar";
import RichLabel from "loracoms/RichLabel";
import Link from "loracoms/Link";
import IntlMsg from "lorautils/intl/IntlMsg";
import usageActions from "loraactions/usage";
import orgActions from "loraactions/org";
import deviceActions from "loraactions/device";
import enumsActions from "loraactions/enums";
import { enumsToOptions } from "lorautils/api/selector";
import { callAPI } from "lorautils/api";
import { addOTAA } from "loraapi/lora_device";
import { normalizeDevEUI, normalizeDevAddr } from "lorautils/IdUtils";
import downloadAsCSV from "lorautils/csvdl";
import { pageParams, updateMarks } from "lorautils/pagerUtil";
import ImportABPModal from "../ImportABPModal";
import ImportOTAAModal from "../ImportOTAAModal";
import DeviceOOQModal from "../DeviceOOQModal";
import PageSizer from "loracoms/PageSizer";
import styles from "./styles.scss";
import { formatTime } from "lorautils/DateTimeUtils";

const kNotReady = "not-ready";
const kOOQ = "ooq";
const kOk = "ok";
const kRouterAction = ["REPLACE", "POP"];
const kMarksKey = "appDevMarks";
const kDlKeys = [
  "deveui",
  "devaddr",
  "nwkskey",
  "appskey",
  "appkey",
  "band",
  "city",
  "area",
  "address",
  "lng",
  "lat",
  "lastact",
  "class",
  "lwanver",
  "name",
  "type",
  "rxwindow",
  "rx2dr",
  "rx2freq",
  "vendor",
  "vendorver",
];

function isNewDevice(device) {
  return differenceInSeconds(new Date(), device.createdAt) < 10;
}

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  appId: React.PropTypes.string.isRequired,
  plan: React.PropTypes.object.isRequired,
  getNodesUsage: React.PropTypes.func.isRequired,
  getOrgBasic: React.PropTypes.func.isRequired,
  basic: React.PropTypes.object.isRequired,
  usage: React.PropTypes.object.isRequired,
  countDevices: React.PropTypes.func.isRequired,
  getBands: React.PropTypes.func.isRequired,
  bandOpts: React.PropTypes.array.isRequired,
  routerAction: React.PropTypes.string.isRequired,
};

class DeviceList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      basic: props.basic,
      plan: props.plan,
      usage: props.usage,
      devices: [],
      checked: [],
      status: "idle",
      initialLoad: "pending",
      deleting: false,
      bandOpts: props.bandOpts,
      sort: "-ctime",
      limit: 20,
    };
    this.deleteQueue = [];
    this.loadList = [];
    this.mark = 0;
    this.page = 0;
    this.handleChangeMark = this.handleChangeMark.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleToggleCheckAll = this.handleToggleCheckAll.bind(this);
    this.handleAutoGen = this.handleAutoGen.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleAdded = this.handleAdded.bind(this);
    this.handleExportAll = this.handleExportAll.bind(this);
    this.handleChangePageSize = this.handleChangePageSize.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.intlMsg = new IntlMsg(
      props.intl,
      "applicationdetail.detailview.devicelist"
    );
  }

  componentWillMount() {
    const { getBands } = this.props;
    getBands();
  }

  componentDidMount() {
    this.loadDevices();
  }

  componentWillReceiveProps(nextProps) {
    const { plan, basic, usage, bandOpts } = nextProps;
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
    if (basic !== this.props.basic) {
      this.setState({ basic });
    }
    if (usage !== this.props.usage) {
      this.setState({ usage });
    }
    if (bandOpts !== this.props.bandOpts) {
      this.setState({ bandOpts });
    }
  }

  //改变页面显示数量
  handleChangePageSize(length) {
    this.setState({ limit: length });
    this.mark = 0;
    this.loadDevices(length);
  }

  //翻页
  handleChangeMark(flag) {
    const { limit } = this.state;
    if (flag) {
      //下一页
      this.mark += limit;
    } else {
      //上一页
      this.mark -= limit;
      this.mark = this.mark < 0 ? 0 : this.mark;
    }
    this.loadDevices();
  }

  loadDevices(length) {
    const { appId } = this.props;
    const { sort } = this.state;
    const { limit } = this.state;

    callAPI({
      endpoint: "/lora/nodes",
      query: {
        app: appId,
        sort,
        limit: length || limit,
        q: this.q,
        mark: this.mark,
      },
    })
      .then((data) => {
        const { list, more } = data;
        this.setState({
          devices: list,
          checked: [],
          status: "success",
          initialLoad: "success",
          more,
        });
      })
      .catch(() => {
        this.setState({
          status: "failure",
          initialLoad: "failure",
        });
      });
  }

  handleSearch(e) {
    const search = e.target.value;
    this.setState({
      search,
    });
    this.mark = 0;

    if (search.length > 0) {
      const s = search.replace(/[:-]/g, "");
      this.q = `or,name:*${s}*,deveui:*${s}*,devaddr:*${s}*,appIdeui:${s}*,city:*${s}*,area:*${s}*,band:*${s}*`;
      this.loadDevices();
    } else {
      this.q = null;
      this.loadDevices();
    }
  }

  allChecked() {
    const { devices, checked } = this.state;
    return devices.length > 0 && devices.length === checked.length;
  }

  isChecked(d) {
    return _.some(this.state.checked, { deveui: d.deveui });
  }

  toggleCheck(d) {
    const checked = this.state.checked;
    if (this.isChecked(d)) {
      this.setState({
        checked: _.filter(checked, (a) => a.deveui !== d.deveui),
      });
    } else {
      checked.push(d);
      this.setState({ checked });
    }
  }

  handleToggleCheckAll() {
    this.setState({
      checked: this.allChecked() ? [] : this.state.devices,
    });
  }

  checkOOQ() {
    const { basic, usage } = this.state;
    if (!basic.status === "success" || usage.pendings.includes("nodes")) {
      return kNotReady;
    }

    const {
      data: { lrnodenum },
    } = basic;
    if (usage.nodes >= lrnodenum) {
      return kOOQ;
    }

    return kOk;
  }

  handleAutoGen(band) {
    const ooqCheck = this.checkOOQ();
    if (ooqCheck === kNotReady) {
      return;
    }
    if (ooqCheck === kOOQ) {
      this.setState({ error: "QUOTA" });
      return;
    }

    this.setState({ error: null });
    const { appId } = this.props;
    const rand = (length) =>
      _.map(_.range(length), () => _.sample("ABCDEF0123456789")).join("");
    addOTAA(appId, rand(16), rand(32), band)
      .then(() => {
        this.handleAdded();
      })
      .catch((err) => {
        this.setState({ error: err.errcode });
      });
  }

  handleDelete() {
    const { checked = [] } = this.state;

    // tag 'deleting' status to devices
    let { devices = [] } = this.state;
    devices = devices.map((dev) => {
      if (_.findIndex(checked, (d) => d.id === dev.id) >= 0) {
        return {
          ...dev,
          deleting: true,
        };
      }
      return dev;
    });
    this.setState({
      deleting: true,
      devices,
    });
    this.mark = 0;

    const { appId, getNodesUsage, getOrgBasic, countDevices } = this.props;

    const deleteDone = () => {
      this.loadDevices();
      getOrgBasic();
      getNodesUsage();
      countDevices({ app: appId });
      this.setState({ deleting: false });
    };

    this.deleteQueue = _.concat(this.deleteQueue, checked);

    // delete device one by one
    // cannot delete concurrently due to a backend bug
    const delFunc = () => {
      if (this.deleteQueue.length > 0) {
        const dev = this.deleteQueue.pop();
        callAPI({
          endpoint: `/lora/nodes/${dev.id}`,
          method: "DELETE",
        })
          .then(() => {
            _.find(devices, (d) => d.id === dev.id).deleted = true;
            this.setState({ devices });
            delFunc();
          })
          .catch(() => {
            _.find(devices, (d) => d.id === dev.id).deleting = false;
            this.setState({ devices });
            delFunc();
          });
      } else {
        deleteDone();
      }
    };

    delFunc();
  }

  handleAdded() {
    const { appId, getOrgBasic, getNodesUsage, countDevices } = this.props;

    this.setState({
      showImport: false,
    });
    this.mark = 0;

    getOrgBasic();
    getNodesUsage();
    countDevices({ app: appId });
    this.loadDevices();
  }

  handleImport(type) {
    const ooqCheck = this.checkOOQ();
    if (ooqCheck === kNotReady) {
      return;
    }
    if (ooqCheck === kOOQ) {
      this.setState({ error: "QUOTA" });
      return;
    }
    this.setState({ error: null });

    const { appId, pushState } = this.props;
    this.importType = type;
    this.setState({
      showImport: true,
    });

    this.type = type;
    if (type === "abp" || type === "otaa") {
      this.setState({ showImport: true });
    } else if (type === "batch") {
      pushState(`/application/${appId}/batchimp`);
    }
  }

  handleExportAll() {
    const { appId } = this.props;
    this.loadList = [];
    let limit = 999;

    const downloadFun = () => {
      callAPI({
        endpoint: "/lora/nodes",
        query: {
          app: appId,
          sort: "-ctime",
          limit: limit,
          mark: this.page,
        },
      })
        .then((data) => {
          this.loadList = [...this.loadList, ...data.list];
          this.page += limit;
          if (data.more) {
            downloadFun();
          } else {
            this.loadList.forEach((item) => {
              item.lastact = item.lastact
                ? format(item.lastact * 1000, "YYYY/MM/DD HH:mm:ss")
                : "";
            });
            downloadAsCSV(
              this.loadList,
              `${appId}_${format(new Date(), "YYYYMMDDHHmmss")}.csv`,
              kDlKeys
            );
            this.page = 0;
            return;
          }
        })
        .catch(() => {});
    };
    downloadFun();
    return;
  }

  handleSort(sort) {
    this.mark = 0;
    this.setState({ sort }, () => {
      this.loadDevices();
    });
  }

  renderDevices() {
    const { appId } = this.props;
    let {
      status = "",
      more = false,
      sort,
      devices = [],
      initialLoad,
      showSearchable,
      usage,
      limit,
    } = this.state;

    const thead = (
      <thead>
        <tr>
          <th className={styles.checkbox}>
            <Checkbox
              id="all"
              checked={this.allChecked()}
              onChange={(e) => this.handleToggleCheckAll(e)}
            />
          </th>
          <th>
            {this.intlMsg.msg("thead.name")}
            <SearchFlag show={showSearchable} />
            <SortBtn
              iconType="alpha"
              handleSort={this.handleSort}
              data={devices}
              sortName="name"
              highLight={sort.indexOf("name") > -1}
            />
          </th>
          <th>
            DevEUI
            <SearchFlag show={showSearchable} />
            <SortBtn
              iconType="alpha"
              handleSort={this.handleSort}
              sortName="deveui"
              highLight={sort.indexOf("deveui") > -1}
            />
          </th>
          <th>
            DevAddr
            <SearchFlag show={showSearchable} />
            <SortBtn
              iconType="alpha"
              handleSort={this.handleSort}
              sortName="devaddr"
              highLight={sort.indexOf("devaddr") > -1}
            />
          </th>
          <th>
            {this.intlMsg.msg("thead.city")}
            <SearchFlag show={showSearchable} />
          </th>
          <th>
            {this.intlMsg.msg("thead.area")}
            <SearchFlag show={showSearchable} />
          </th>
          <th>{this.intlMsg.msg("thead.type")}</th>
          <th> {this.intlMsg.msg("thead.band")} </th>
          <th>
            {this.intlMsg.msg("thead.status")}
            <SortBtn
              iconType="number"
              handleSort={this.handleSort}
              sortName="lastact"
              ascSort={false}
              highLight={sort.indexOf("lastact") > -1}
            />
          </th>
          <th>
            {this.intlMsg.msg("thead.createtime")}
            <SortBtn
              iconType="number"
              handleSort={this.handleSort}
              sortName="ctime"
              ascSort={false}
              highLight={sort.indexOf("ctime") > -1}
            />
          </th>
        </tr>
      </thead>
    );

    if (initialLoad === "pending") {
      const { nodes = 1 } = usage;
      const rows = Math.max(1, Math.min(nodes, 10));
      return (
        <LoadingTable
          className="aisz-table-light"
          striped
          bordered
          rows={rows}
          cols={10}
        >
          {thead}
        </LoadingTable>
      );
    }

    const pager = (
      <TablePagers
        status={status}
        mark={this.mark}
        more={more}
        change={this.handleChangeMark}
      />
    );
    const rows = devices.map((d) => (
      <tr
        key={d.deveui}
        className={`
          ${isNewDevice(d) ? styles.newDevice : ""}
          ${d.deleting ? styles.deleting : ""}
          ${d.deleted ? styles.deleted : ""}
        `}
      >
        <td className={styles.checkbox}>
          <Checkbox
            id={d.deveui}
            checked={this.isChecked(d)}
            onChange={() => this.toggleCheck(d)}
          />
        </td>
        <td>{d.name}</td>
        <td>
          <Link to={`/application/${appId}/devices/${d.id}`}>
            {normalizeDevEUI(d.deveui)}
          </Link>
        </td>
        <td>{normalizeDevAddr(d.devaddr)}</td>
        <td>{d.city}</td>
        <td>{d.area}</td>
        <td>{d.type}</td>
        <td>
          <RichLabel content={d.band} />
        </td>
        <td>
          <Nvl
            val={d.lastact}
            formatter={(x) =>
              (x && format(x * 1000, "YYYY-MM-DD HH:mm:ss")) || ""
            }
          />
        </td>
        <td>
          <Nvl
            val={d.createdAt}
            formatter={(x) => format(x, "YYYY-MM-DD HH:mm:ss")}
          />
        </td>
      </tr>
    ));

    return (
      <div className={styles.devices}>
        <Table
          className={`aisz-table-light ${styles.deviceList}`}
          striped
          hover
          bordered
          responsive
        >
          {thead}
          <tbody>{rows}</tbody>
        </Table>
        <ShowIf if={devices.length > 0}>
          <div>
            <div className={styles.pager}>
              <PageSizer
                pageSize={limit}
                onChange={this.handleChangePageSize}
                options={[20, 100, 500]}
              />
            </div>
            <div className={styles.pagers}>{pager}</div>
          </div>
        </ShowIf>

        <ShowIf if={devices.length === 0}>
          <div className={styles.noDevice}>
            <h3>{this.intlMsg.msg("nodevice")}</h3>
          </div>
        </ShowIf>
      </div>
    );
  }

  render() {
    const { search = "", bandOpts } = this.state;
    const gen = (
      <DropdownButton
        id="gen-devices"
        bsStyle="aisz-success-b"
        title={
          <span>
            <i className="fa fa-random" /> {this.intlMsg.msg("gendev")}
          </span>
        }
      >
        {bandOpts.map((bandOpt) => (
          <MenuItem
            key={bandOpt.label}
            eventKey={bandOpt.label}
            onClick={() => this.handleAutoGen(bandOpt.label)}
          >
            <RichLabel
              content={bandOpt.label}
              enums={() => ({
                translate: <i className="fa fa-circle" />,
              })}
              inverse
            />
            {this.intlMsg.msg("gendev.band")} {bandOpt.label}
          </MenuItem>
        ))}
      </DropdownButton>
    );
    const imp = (
      <DropdownButton
        id="imp-device"
        bsStyle="aisz-success"
        title={
          <span>
            <i className="fa fa-arrow-circle-right" />{" "}
            {this.intlMsg.msg("impdev")}
          </span>
        }
      >
        <MenuItem eventKey="2" onClick={() => this.handleImport("abp")}>
          <i className="fa fa-angle-right fa-fw" />{" "}
          {this.intlMsg.msg("importabp")}
        </MenuItem>
        <MenuItem eventKey="3" onClick={() => this.handleImport("otaa")}>
          <i className="fa fa-angle-right fa-fw" />{" "}
          {this.intlMsg.msg("importotaa")}
        </MenuItem>
        <MenuItem eventKey="4" onClick={() => this.handleImport("batch")}>
          <i className="fa fa-angle-double-right fa-fw" />{" "}
          {this.intlMsg.msg("batchimport")}
        </MenuItem>
      </DropdownButton>
    );
    const del = (
      <Button
        bsStyle="aisz-danger-b"
        onClick={this.handleDelete}
        disabled={_.isEmpty(this.state.checked) || this.state.deleting}
      >
        {this.state.deleting ? (
          <i className="fa fa-spinner fa-spin" />
        ) : (
          <i className="fa fa-trash-o" />
        )}{" "}
        {this.intlMsg.msg("deldev")}
      </Button>
    );
    const searchInput = (
      <SearchInput
        onChange={this.handleSearch}
        value={search}
        placeholder={this.intlMsg.msg("search.placeholder")}
        onFocus={() => this.setState({ showSearchable: true })}
        onBlur={() => this.setState({ showSearchable: false })}
      />
    );
    const exp = (
      <Button bsStyle="aisz-info-b" onClick={this.handleExportAll}>
        <i className="fa fa-download" /> {this.intlMsg.msg("expalldev")}
      </Button>
    );
    const tools = [searchInput, imp, gen, exp, del];

    const { appId } = this.props;
    const { showImport, error } = this.state;

    return (
      <Panel bsStyle="aisz-white" header={this.intlMsg.msg("title")}>
        <PanelToolbar tools={tools} />
        {this.renderDevices()}
        <div>
          <DeviceOOQModal
            show={error === "QUOTA"}
            onHide={() => {
              this.setState({ error: null });
            }}
          />
          <ImportOTAAModal
            show={showImport && this.importType === "otaa"}
            onHide={() => this.setState({ showImport: false })}
            onSucc={this.handleAdded}
            onOOQ={() => {
              this.setState({ error: "QUOTA" });
            }}
            appeui={appId}
          />
          <ImportABPModal
            show={showImport && this.importType === "abp"}
            onHide={() => this.setState({ showImport: false })}
            onSucc={this.handleAdded}
            onOOQ={() => {
              this.setState({ error: "QUOTA" });
            }}
            appeui={appId}
          />
        </div>
      </Panel>
    );
  }
}

DeviceList.propTypes = propTypes;

const mapStateToProps = (state) => ({
  plan: state.billing.plan,
  basic: state.org.basic,
  usage: state.usage,
  bandOpts: enumsToOptions("bands", state),
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getNodesUsage: usageActions.nodes,
  getOrgBasic: orgActions.basic,
  countDevices: deviceActions.countDevices,
  getBands: enumsActions.bands,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(DeviceList));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DetailView/coms/DeviceList/index.jsx